import { render, staticRenderFns } from "./loginComponent.vue?vue&type=template&id=668a5f0e&scoped=true&"
import script from "./loginComponent.vue?vue&type=script&lang=js&"
export * from "./loginComponent.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=668a5f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668a5f0e",
  null
  
)

export default component.exports